









import { Vue, Component } from 'vue-property-decorator';
import DashboardServices from '@/services/dashboard';
import { getRange } from '@/libs/time';
import LabelTag from './LabelTag.vue';
@Component({
  components: { LabelTag }
})
export default class LeftChart1 extends Vue {
  dashSrv = new DashboardServices();

  option: any = {
    xAxis: {
      data: [],
      boundaryGap: false,
      axisLine: {
        style: {
          stroke: '#999'
        }
      },
      axisLabel: {
        style: {
          fill: '#999'
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      data: 'value',
      splitLine: {
        show: false
      },
      axisLine: {
        style: {
          stroke: '#999'
        }
      },
      axisLabel: {
        style: {
          fill: '#999'
        }
      },
      axisTick: {
        show: false
      },
      min: 0
    },
    series: [
      {
        data: [],
        type: 'line',
        smooth: true,
        lineArea: {
          show: true,
          gradient: ['rgba(55, 162, 218, 0.6)', 'rgba(55, 162, 218, 0)']
        },
        linePoint: {
          radius: 3,
          style: {
            fill: '#00db95'
          }
        }
      }
    ]
  };

  created() {
    let [startTime, endTime] = getRange('total');
    this.getTrend({ startTime, endTime, alertLevel: '1' });
  }

  async getTrend(params?: any) {
    let list = await this.dashSrv.getTrend(params);
    let xAxisData: any = [];
    let seriesData: any = [];
    list.forEach((v: any) => {
      xAxisData.push(v.alertDate);
      seriesData.push(v.value);
    });
    this.option.series[0].data = seriesData;
    this.option.xAxis.data = xAxisData;
  }
}
